import { Injectable } from '@angular/core';
import { SigningServiceHttp } from '../signing-service';
@Injectable({
  providedIn: 'root'
})
export class VerificationPageService {

  constructor(private http:SigningServiceHttp) { }

  /**
   * get the verification detail when all parties signed a document
   * @param role_id 
   * @param document_id 
   * @returns 
   */
  verification(role_id: string, document_id: number) {
    return this.http.get(`sign-document/${role_id}/${document_id}/verification`);
  }
}
